var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommuComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00293 11.9995C4.00293 7.58123 7.58465 3.99951 12.0029 3.99951V3.99951C16.4212 3.99951 20.0029 7.58123 20.0029 11.9995V17.0904C20.0029 17.7414 20.0029 18.0668 19.9349 18.3347C19.7354 19.1193 19.1227 19.732 18.3381 19.9314C18.0703 19.9995 17.7448 19.9995 17.0938 19.9995H12.0029C7.58465 19.9995 4.00293 16.4178 4.00293 11.9995V11.9995Z",
    stroke: "#FF6019",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11L15 11",
    stroke: "#FF6019",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 15.0002H14.998",
    stroke: "#FF6019",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommuComment);
export default __webpack_public_path__ + "static/media/CommuComment.762a15c2.svg";
export { ForwardRef as ReactComponent };